import type { AccountNode } from '@taler/api-client'
import { type Locale, resolveLocalized } from '@taler/domain'

/** The ledger's FX gain/loss account: the journal's own residual leg for a cross-currency entry, never one the user chose. */
export const FX_RESIDUAL_CODE = 'EQUITY.FX_GAIN_LOSS'

export interface AccountLabel {
  readonly id: string
  readonly code: string
  /** The account's own name, in the active locale. */
  readonly leaf: string
  /** Class root to the account itself, both included. */
  readonly path: readonly string[]
}

export function indexAccountLabels(
  nodes: readonly AccountNode[],
  locale: Locale,
): ReadonlyMap<string, AccountLabel> {
  const labels = new Map<string, AccountLabel>()
  const walk = (level: readonly AccountNode[], ancestors: readonly string[]): void => {
    for (const { account, children } of level) {
      const leaf = resolveLocalized(account.names, locale)?.name ?? account.code
      const path = [...ancestors, leaf]
      labels.set(account.id, { id: account.id, code: account.code, leaf, path })
      walk(children, path)
    }
  }
  walk(nodes, [])
  return labels
}
